@if (isLoading) {
  <ion-card>
    <app-loader />
  </ion-card>
}

@if (!isLoading && maintenanceTasks !== null) {
  <ion-card (click)="emitClick()"
    data-cy="overdue-maintenance-list-container">
    @if (maintenanceTasks.length > 0) {
      <ion-card-header>
        <span class="mobile-only">Top {{ Math.min(numberOfMaintenanceTasksToShow, maintenanceTasks.length) }}
          @if (maintenanceTasks.length === 1) {
            <span>Aandachtspunt</span>
          }
          @if (maintenanceTasks.length > 1) {
            <span>Aandachtspunten</span>
          }
        </span>
        Periodiek Onderhoud
      </ion-card-header>
      <!--    <p class="explanation">Aantal dagen totdat dit onderhoud weer gedaan moet worden:</p>-->
      <ul class="list-of-maintenancetasks">
        @for (task of maintenanceTasks; track task) {
          <li
            [style.color]="task.daysUntilNextCompletion < 0 || task.daysUntilNextCompletion == null ? 'red' : task.daysUntilNextCompletion > 0 ? '#666666' : 'black'"
            [style.font-weight]="task.daysUntilNextCompletion < 0 || task.daysUntilNextCompletion == null ? 'bold' : 'default'"
            style="display: flex; align-items: center;justify-content: space-between;"
            >
            @if (task.daysUntilNextCompletion == null) {
              <!--          <span>❕ {{ task.name }}:</span> <span>nog nooit gedaan</span>-->
              <span>{{ task.name }}:</span> <span class="date-indication">nog nooit gedaan</span>
            }
            @if (task.daysUntilNextCompletion < 0 && task.daysUntilNextCompletion > 0 && task.daysUntilNextCompletion != null ) {
              <!--          <span>⚠️ {{ task.name }}:</span>-->
              <span>{{ task.name }}:</span> <span
              class="date-indication"> {{ Math.abs(task.daysUntilNextCompletion) }}
              @if (Math.abs(task.daysUntilNextCompletion) == 1) {
                <span
                >dag</span>
                }@if (Math.abs(task.daysUntilNextCompletion) > 1) {
                <span
                >dagen</span>
              } te laat</span>
            }
            @if (task.daysUntilNextCompletion <= 0 && task.daysUntilNextCompletion != 0 && task.daysUntilNextCompletion != null ) {
              <!--          <span>❗ {{ task.name }}:</span> <span> {{ Math.abs(task.daysUntilNextCompletion) }} dagen te laat</span>-->
              <span>{{ task.name }}:</span> <span
              class="date-indication"> {{ Math.abs(task.daysUntilNextCompletion) }}
            dagen te laat</span>
          }
          @if (task.daysUntilNextCompletion > 0 && task.daysUntilNextCompletion != 0 && task.daysUntilNextCompletion != null ) {
            <!--          <span>⌛ {{ task.name }}:</span> <span> over {{ Math.abs(task.daysUntilNextCompletion) }} <span-->
            <span>{{ task.name }}:</span> <span
            class="date-indication"> over {{ Math.abs(task.daysUntilNextCompletion) }}
            @if (Math.abs(task.daysUntilNextCompletion) == 1) {
              <span
              >dag</span>
              }@if (Math.abs(task.daysUntilNextCompletion) > 1) {
              <span
              >dagen</span>
            }</span>
          }
          @if (task.daysUntilNextCompletion == 0 && task.daysUntilNextCompletion != null) {
            <span>{{ task.name }}:</span> <span class="date-indication"> vandaag</span>
            <!--          <span>⏰ {{ task.name }}:</span> <span> vandaag</span>-->
          }
          <!--        &#45;&#45;&#45;&#45; {{ task.daysUntilNextCompletion }} &#45;&#45;&#45;&#45;-->
          <!--        <span [style.color]="task.daysUntilNextCompletion < 0 ? 'red' : 'black'"-->
          <!--              [style.font-weight]="task.daysUntilNextCompletion < 0 ? 'bold' : 'default'" class="number-of-days">-->
          <!--        <span *ngIf="task.daysUntilNextCompletion>0">over </span>{{ Math.abs(task.daysUntilNextCompletion) }}</span>-->
          <!--        <span-->
          <!--          [style.color]="task.daysUntilNextCompletion < 0 ? 'red' : 'black'"-->
        <!--          [style.font-weight]="task.daysUntilNextCompletion < 0 ? 'bold' : 'default'">dagen</span>-->
        <!--        <span *ngIf="task.daysUntilNextCompletion<0" [style.color]="task.daysUntilNextCompletion < 0 ? 'red' : 'black'"-->
      <!--              [style.font-weight]="task.daysUntilNextCompletion < 0 ? 'bold' : 'default'"> geleden</span>: {{ task.name }}-->
    </li>
  }
</ul>
<!--    <ion-icon class="center-right" name="chevron-forward-outline" />-->
} @else {
  <ion-card-header style="padding-bottom:1rem;">
    Geen periodiek onderhoud gevonden
  </ion-card-header>
}
<!-- Mobile view -->
<div class="view-maintenance-link mobile-only">
  <ion-icon name="arrow-forward-outline"></ion-icon>
  Bekijk onderhoud
</div>
<!-- Desktop view -->
<div class="view-maintenance-link desktop-only">
  <ion-button (click)="emitClick()" expand="block" fill="clear">
    <ion-icon name="arrow-forward-outline"></ion-icon>
    Bekijk Onderhoud
  </ion-button>
</div>
<!--  <ion-icon class="center-right" name="chevron-forward-outline" />-->
</ion-card>
}
